const agentStatus = {
  PENDING: 0,
  APPROVED: 1,
  REJECTED: 2,
};

export default agentStatus;
